/* eslint-disable react/forbid-component-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'sugar-design';

import { parsePhone, stringifyPhone } from '@/utils/common';

// stylesheet
import styles from './index.cm.styl';

/**
 * 电话输入框
 * 增加对国家调用代码的支持
 */
class PhoneInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusing: false,
    };
    this.onFocus = () => this.setState({ focusing: true });
    this.onBlur = this.onBlur.bind(this);
    this.onChangeCallingCode = this.onChangeCallingCode.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onPhoneValueRefChange = (ref) => (this.phoneValueRef = ref);
    this.onCallingCodeRefChange = (ref) => (this.callingCodeRef = ref);
  }

  onChangeCallingCode(event) {
    const value = parseInt(event.target.value);
    const callingCodeValue = isNaN(value) ? '' : value.toString();
    this.props.onChange(stringifyPhone([callingCodeValue, this.phoneValueRef.value], true));
  }

  onChangePhone(event) {
    const value = event.target.value;
    const phoneVal = value.trim();
    this.props.onChange(stringifyPhone([this.callingCodeRef.value, phoneVal], true));
  }

  onBlur() {
    this.setState({ focusing: false });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  render() {
    const { focusing } = this.state;
    const {
      containerClassName,
      placeholder,
      codePlaceholder = '86',
      value: phoneStr,
      error,
      errorClassName,
      showErrorIcon,
      showErrorMessage,
    } = this.props;
    const [callingCode, phoneVal] = parsePhone(phoneStr, true);
    return (
      <div
        className={classNames(styles.wrapper, containerClassName, {
          [styles.error]: !!error,
          [styles.focusing]: focusing,
        })}
      >
        <div className={styles.callingCodeBox}>
          <input
            ref={this.onCallingCodeRefChange}
            type="text"
            className={classNames(styles.resetInput, styles.callingCodeInput)}
            placeholder={codePlaceholder}
            maxLength="4"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.onChangeCallingCode}
            value={callingCode || ''}
          />
          <span className={styles.callingCodeSymbol}>+</span>
          <span className={styles.separatorSymbol}>-</span>
        </div>
        <div className={styles.phoneBox}>
          <input
            ref={this.onPhoneValueRefChange}
            type="text"
            className={classNames(styles.resetInput, styles.phoneInput)}
            placeholder={placeholder}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.onChangePhone}
            value={phoneVal || ''}
          />
          {showErrorIcon && error && <Icon name="warning" className={styles.iconInputError} />}
        </div>
        {error && showErrorMessage && (
          <span className={classNames(styles.errorMsg, errorClassName)}>
            <Icon name="clear" size="12" style={{ paddingRight: '4px' }} />
            {error}
          </span>
        )}
      </div>
    );
  }
}

PhoneInput.defaultProps = {
  placeholder: '',
  containerClassName: null,
  onChange: () => {},
  showErrorIcon: false,
  showErrorMessage: true,
};

PhoneInput.propTypes = {
  containerClassName: PropTypes.string,
  /**
   * 简藏 的 error 会显示 icon 图标
   */
  showErrorIcon: PropTypes.bool,
  /**
   * 是否展示错误信息
   */
  showErrorMessage: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

export default PhoneInput;
